(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-reviews-custom"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-reviews-custom-carousel')) {
    customElements.define(
      'customer-reviews-custom-carousel',
      class ReviewsCarousel extends HTMLElement {
        connectedCallback() {
          this.list = this.querySelector('[data-reviews-track]');
          this.slides = Array.from(this.querySelectorAll('[data-reviews-slide]'));
          this.prevButton = this.querySelector('[data-reviews-prev]');
          this.nextButton = this.querySelector('[data-reviews-next]');

          if (!this.list || this.slides.length === 0) return;

          this.onPrev = () => this.go(-1);
          this.onNext = () => this.go(1);
          this.onScroll = () => this.updateButtons();
          this.onBlockSelect = (event) => {
            if (!this.contains(event.target)) return;
            event.target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          };

          this.prevButton?.addEventListener('click', this.onPrev);
          this.nextButton?.addEventListener('click', this.onNext);
          this.list.addEventListener('scroll', this.onScroll, { passive: true });
          this.resizeObserver = new ResizeObserver(() => this.updateButtons());
          this.resizeObserver.observe(this.list);
          document.addEventListener('shopify:block:select', this.onBlockSelect);
          this.updateButtons();
        }

        disconnectedCallback() {
          this.prevButton?.removeEventListener('click', this.onPrev);
          this.nextButton?.removeEventListener('click', this.onNext);
          this.list?.removeEventListener('scroll', this.onScroll);
          this.resizeObserver?.disconnect();
          document.removeEventListener('shopify:block:select', this.onBlockSelect);
        }

        get slideOffset() {
          if (this.slides.length < 2) {
            return this.slides[0]?.getBoundingClientRect().width || 0;
          }

          return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
        }

        go(direction) {
          this.list.scrollBy({ left: direction * this.slideOffset, behavior: 'smooth' });
        }

        updateButtons() {
          const maxScroll = this.list.scrollWidth - this.list.clientWidth;
          const canScroll = maxScroll > 4;
          const atStart = this.list.scrollLeft <= 4;
          const atEnd = this.list.scrollLeft >= maxScroll - 4;

          this.classList.toggle('customer-reviews-custom__carousel--static', !canScroll);
          this.prevButton?.toggleAttribute('disabled', !canScroll || atStart);
          this.nextButton?.toggleAttribute('disabled', !canScroll || atEnd);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
